export default __webpack_public_path__ + "static/media/content4-transparent.c29aa3e8.png";